import { ChangeDetectionStrategy, Component, computed, inject, Signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { NewDwellingSalesDataService } from "src/services/new-dwellings/new-dwelling-sales-data.service";
import { NewDwellingSalesStateService } from "src/services/new-dwellings/new-dwelling-sales-state.service";
import { EvDropdownComponent, OptionsObject } from "src/app/shared-components/ev-dropdown/ev-dropdown.component";
import { EvLogoLoaderComponent } from "src/app/shared-components/ev-logo-loader/ev-logo-loader.component";
import { IProjectStageDto } from "src/models/new-dwelling/new-dwelling.model";
import { compareProjectStagesBy, newDwellingListSortOptions } from "./new-dwellings-list-sort.model";
import { NewDwellingStageItemComponent } from "./new-dwelling-stage-item.component";

@Component({
    selector: "new-dwellings-list",
    imports: [NewDwellingStageItemComponent, EvLogoLoaderComponent, EvDropdownComponent],
    templateUrl: "./new-dwellings-list.component.html",
    styleUrl: "./new-dwellings-list.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewDwellingsListComponent {
    private readonly newDwellingDataService = inject(NewDwellingSalesDataService);
    private readonly newDwellingStateService = inject(NewDwellingSalesStateService);

    sales = toSignal(this.newDwellingDataService.sales$);
    protected readonly mapDataIsLoading = this.newDwellingDataService.mapDataIsLoading;
    protected readonly sortKey = this.newDwellingStateService.listSortKey;
    protected readonly sortOptions = newDwellingListSortOptions;

    protected readonly sortedProjects: Signal<IProjectStageDto[]> = computed(() => {
        const projects = this.sales()?.projects ?? [];
        return [...projects].sort(compareProjectStagesBy(this.sortKey()));
    });

    protected setSortKey(option: OptionsObject): void {
        this.newDwellingStateService.setListSortKey(option.key as string);
    }
}
